export default __webpack_public_path__ + "static/media/location.0a973a46.png";